// extracted by mini-css-extract-plugin
export default {"icon":"IconTemperature_icon__ZhIWG"};